import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import { cn, isMainPage } from '@/lib/utils';
import CoverIcon from '@/icon/CoverIcon';
import { isWebview } from '@/utils';
import useScreenViewGa from '@/hooks/useScreenViewGa';

const CommonLayout = () => {
  const location = useLocation();

  useScreenViewGa();

  return (
    <div
      className={cn(`mx-auto tablet:text-sm mobile:text-xs text-neutral-950 min-h-screen`, {
        'bg-gradient-to-r from-red-900 to-red-600 relative': isMainPage(location.pathname),
        'max-w-[1280px]': !isMainPage(location.pathname),
      })}
    >
      {!isWebview() ? <Header /> : null}
      {isMainPage(location.pathname) ? (
        <div className="absolute mobile:right-5 tablet:right-16 top-[70px] mobile:w-[211px] mobile:h-[117px] tablet:w-[335px] tablet:h-[185px]">
          <CoverIcon />
        </div>
      ) : null}
      <div
        className={cn('flex justify-center w-full h-full', {
          'pt-12': !isWebview(),
        })}
      >
        <Outlet />
      </div>
    </div>
  );
};

export default CommonLayout;
